import { collection, doc, getDoc, getDocs, Query, query, setDoc, where } from 'firebase/firestore';
import { IRoute } from '../sp-types/routeType';
import { db } from './firebase';
import { getAllItems, saveItem } from './genericFB';

const ROUTES_COLLECTION_NAME = 'routes';
const DB_LOCATION = db;

export async function createRoute(
  data: IRoute,
  routeId: string,
  callback?: (success: boolean, createdObject?: IRoute) => void,
) {
  try {
    const docRef = doc(DB_LOCATION, ROUTES_COLLECTION_NAME, routeId);
    await setDoc(docRef, data);
    const docSnap = await getDoc(docRef);
    const route = docSnap.data() as IRoute;
    route.id = docSnap.id;
    return route;
  } catch (err) {
    console.log(`Error creating balance flow: ${err}`);
    callback && callback(false);
  }
}

export async function getRoutesByIds(routeIds: string[]): Promise<IRoute[]> {
  try {
    const routes: IRoute[] = [];
    for (const routeId of routeIds) {
      const docRef = doc(DB_LOCATION, ROUTES_COLLECTION_NAME, routeId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const route = docSnap.data() as IRoute;
        route.id = docSnap.id;
        routes.push(route);
      }
    }
    return routes;
  } catch (err) {
    console.log(`Error getting routes by IDs: ${err}`);
    return [];
  }
}

export async function getAllRoutes(): Promise<IRoute[] | undefined> {
  return await getAllItems<IRoute>(ROUTES_COLLECTION_NAME);
}

export async function getRoutesOfMaterial(formulaId: string): Promise<IRoute[] | undefined> {
  return await getAllItems<IRoute>(ROUTES_COLLECTION_NAME, (q: Query) =>
    query(q, where('formulaId', '==', formulaId)),
  );
}

export async function createAllRoutes(routes: any[]) {
  try {
    for (const route of routes) {
      const docRef = doc(DB_LOCATION, ROUTES_COLLECTION_NAME, route.id);
      await setDoc(docRef, route);
    }
  } catch (e) {
    console.log('error ', e);
  }
}

export async function createAllDocs(docs: any[], collectionName: string) {
  try {
    for (const myDoc of docs) {
      const docRef = doc(DB_LOCATION, collectionName, myDoc.id);
      await setDoc(docRef, myDoc);
    }
  } catch (e) {
    console.log('error ', e);
  }
}

export async function getAllDocs(collectionName: string): Promise<any | null> {
  const collectionRef = collection(DB_LOCATION, collectionName);
  try {
    const querySnapshot = await getDocs(collectionRef);

    return (!querySnapshot.empty && querySnapshot.docs.map((doc) => doc.data())) || null;
  } catch (err) {
    console.log(`Error getting Docs: ${err}`);
    return null;
  }
}

export async function getAllRouteIds(): Promise<string[]> {
  const routesRef = collection(DB_LOCATION, ROUTES_COLLECTION_NAME);
  try {
    const querySnapshot = await getDocs(routesRef);
    const routeIds = querySnapshot.docs.map((doc) => doc.id);
    return routeIds;
  } catch (err) {
    console.log(`Error getting route IDs: ${err}`);
    return [];
  }
}

export const updateRoute = async (id: string, route: IRoute): Promise<IRoute | null> => {
  return saveItem<IRoute>(id, route, ROUTES_COLLECTION_NAME);
};
